import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import DeckGL from "@deck.gl/react";
import { API } from 'aws-amplify';
import { PolygonLayer, TextLayer, PointCloudLayer } from "@deck.gl/layers";
import {ScenegraphLayer} from '@deck.gl/mesh-layers';
import { StaticMap, MapContext, NavigationControl } from "react-map-gl";
import {LinearInterpolator} from 'deck.gl';
import { FirstPersonView, MapView } from '@deck.gl/core';
import { subscribeToLiveAircraft } from 'actions/liveAircraftActions';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Accordion, AccordionSummary, AccordionDetails, Tabs, Tab, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as turf from '@turf/turf';
import Page from '../../components/Page/Page';
import { getObstaclesV1Api, getObstaclesV2Api} from '../../actions/obstacleActions';
import { pecanSquareCellId } from '../../constants';
import { getCells } from '../../actions/orderActions';
import { useAppSelector } from 'hooks/redux';
import { selectCells } from '../../selectors/ordersSelector';

const Aerospace3D= ({
}) => {
  const cells = useAppSelector(selectCells);
  const [ADSBUavs, setADSBUavs] = React.useState([]);
  const uavs = useSelector(state => state.liveAircraft.liveData);
  const [selectedCell, setSelectedCell] = useState({
    "id": 7,
    "cellName": "BLANCHARDSTOWN",
    "centerLatitude": 53.39292547693334,
    "centerLongitude": -6.395731067422041
  });
  const [selectedAircraft, setSelectedAircraft] = useState();
  const [obstacleData, setObstacleData] = React.useState(null);
  const [utmSegments, setUTMSegments] = React.useState([]);
  const [useFirstPersonView, setUseFirstPersonView] = React.useState(false);
  const dispatch = useDispatch();
  const MANNA_UAV_MODEL = 'https://bom-api.s3.eu-west-1.amazonaws.com/simulation/gen4-oirientation-fix3.glb';
  const MAP_STYLE = "mapbox://styles/mapbox/light-v9";
  const colors = [
    [0, 255, 0],
    [138, 43, 226],
    [24, 155, 204],
    [255, 255, 0],
    [125, 249, 255]
];
  const NAV_CONTROL_STYLE = {
    position: "absolute",
    top: 10,
    left: 10,
  };
  const [viewState, setViewState] = React.useState({
    longitude: selectedCell.centerLongitude,
    latitude: selectedCell.centerLatitude,
    zoom: 15,
    pitch: 70,
    bearing: 40
  });

  useEffect(() => {
    dispatch(subscribeToLiveAircraft());
    loadAndSetCells();
    return () => {};
  }, []);

  useEffect(() => {
    const fetchUTMAirspaceData = async () => {
      API.get('api', `/airspace/utm/${selectedCell.id}`)
      .then(res => {
        const data = res.map(f => ({
          volume: transformFeatureCollection(f, colors[1]),
        }))
        setUTMSegments(data);
      })
      .catch(e => {
        console.error(e);
      });
    };
    const intervalId = setInterval(fetchUTMAirspaceData, 5000);
    return () => clearInterval(intervalId);
  }, [selectedCell]);

  function transformFeatureCollection(featureCollection, color) {
    return featureCollection.features?.map(feature => {
      const lowerAltitude = feature.properties.altitudeLower;
      const upperAltitude = feature.properties.altitudeUpper;
      const timeStart = feature.properties.timeStart;
      const timeEnd = feature.properties.timeEnd;
      let volumes = [];
      feature.geometry.coordinates.forEach(polygon => {
        polygon.forEach(coordinate => {
          volumes.push([coordinate[0], coordinate[1], lowerAltitude]);
        });
      });
      return { volumes, lowerAltitude, upperAltitude, color, timeStart, timeEnd};
    });
  }

  useEffect(() => {

    const fetchObstacles = async () => {

      try {
        const obstaclesV1Promise = await getObstaclesV1Api(selectedCell.id);
        const obstaclesV2Promise = selectedCell.id !== pecanSquareCellId ? await getObstaclesV2Api(selectedCell.id) : Promise.resolve([]);
    
        const [res1, res2] = await Promise.all([obstaclesV1Promise, obstaclesV2Promise]);
        const combinedResult = res2.length ? [...res1, ...res2] : res1;
  
        setObstacleData(combinedResult);
      } catch (error) {
        console.error(error);
      }
    };

    const intervalId = setInterval(fetchObstacles, 5000);
    return () => clearInterval(intervalId);
  }, [selectedCell, cells]);

  useEffect(() => {
    const fetchADSBAircrafts = async () => {
      const url = 'https://corsproxy.io/?' + encodeURIComponent(`http://api.airplanes.live/v2/point/${selectedCell.centerLatitude}/${selectedCell.centerLongitude}/50`);
      const response = await fetch(url);
      const data = await response.json();;
      setADSBUavs(data.ac.filter(ac => ac.mag_heading || ac.nav_heading).map(ac => ({
        position: [ac.lon, ac.lat, ac.alt_geom],
        bearing: ac.mag_heading ? ac.mag_heading : ac.nav_heading,
        altitude: 40,
        id: ac.flight
      })));
    };

    fetchADSBAircrafts();
    const interval = setInterval(fetchADSBAircrafts, 1000);

    return () => clearInterval(interval);
  }, [selectedCell]);

  const uavData = Object.values(uavs)?.filter(uav => {
    return true;
  });

  const modifiedUTMVolumes = utmSegments.flatMap(s =>
    s.volume?.map((vol, volumeIndex) => ({
        volume: vol.volumes,
        upper: vol.upperAltitude,
        lower: vol.lowerAltitude,
        color: vol.color
    }))
  );

  const utmSnake = utmSegments?.flatMap(s => {
    const currentTimeInMilliseconds = Date.now() / 1000;
    const currentVolumes = s.volume?.filter(v => {
      return v.timeStart <= currentTimeInMilliseconds && v.timeEnd >= currentTimeInMilliseconds;
    }).map((v, segmentIndex) => {
      return {
        contour: v.volumes,
        upper: v.upperAltitude,
        lower: v.lowerAltitude,
        color: v.color,
        timeStart: v.timeStart,
        timeEnd: v.timeEnd
      };
    });
    return currentVolumes ?? [];
  });

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function loadAndSetCells() {
    dispatch(getCells());
  }

  function handleCellClick(cell) {
    if(selectedAircraft){
      return;
    }
    setSelectedCell(cell);
    setViewState({
      ...viewState,
      longitude: cell.centerLongitude,
      latitude: cell.centerLatitude
    });
  }

  function handleUAVlick(uav) {
    if(selectedAircraft) {
      setSelectedAircraft(null);
      setViewState({
        ...viewState,
        longitude: selectedCell.centerLongitude,
        latitude: selectedCell.centerLatitude,
        zoom: 15,
        pitch: 70,
        bearing: 40
      });
    } else {
      setSelectedAircraft(
        {
          "id": uav.uavId,
          "type": "uav"
        }
      )
    }
  }

  useEffect(() => {
    if (selectedAircraft) {
      let selectedData;

      if (selectedAircraft.type === 'adsb') {
        selectedData = ADSBUavs.find(uav => uav.id === selectedAircraft.id);
      } else if (selectedAircraft.type === 'uav') {
        selectedData = uavData.find(uav => uav.uavId === selectedAircraft.id);
      }

      const transitionInterpolator = new LinearInterpolator(['longitude', 'latitude', 'bearing', 'pitch']);
      const transitionDuration = 2000;

      if (selectedData) {
        setViewState(viewState => ({
          ...viewState,
          longitude:selectedAircraft.type === 'uav' ? selectedData.currentPosition[1] : selectedData.position[1],
          latitude: selectedAircraft.type === 'uav' ? selectedData.currentPosition[0] : selectedData.position[0],
          bearing: selectedAircraft.type === 'uav' ? selectedData.compass : selectedData.bearing,
          zoom: 17,
          pitch: 60,
          transitionInterpolator,
          transitionDuration
        }));
      }
    }
  }, [selectedAircraft, uavData, ADSBUavs]);

  const isWithin10Km = (point1, point2) => {
    const from = turf.point(point1);
    const to = turf.point(point2);
    const options = { units: 'kilometers' };
    const distance = turf.distance(from, to, options);
    return distance <= 10;
  };

  const filteredUAVData = uavData?.filter((a) =>
    isWithin10Km([selectedCell.centerLongitude, selectedCell.centerLatitude], [a.currentPosition[1],a.currentPosition[0]])
  );

  return (
    <Page className="top-0 left-0 right-0 bottom-0 mt-6">
      <Accordion style={{
      position: 'absolute',
      top: '80px',
      right: '10px',
      width: '400px',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      color: 'white',
      borderRadius: '10px',
      zIndex: 10,
    }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
      </AccordionSummary>
      <AccordionDetails style={{ minHeight: "200px", maxHeight: "800px" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: "white"
            }
          }}
        >
          <Tab label="CELLS"  style={{ color: "white" }} />
          <Tab label="UAVS"  style={{ color: "white" }} />
        </Tabs>
        <Box role="tabpanel" hidden={value !== 0}>
          <List
              sx={{ width: '100%', maxWidth: 360, bgcolor: 'rgba(0, 0, 0, 0.0)' }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              {cells?.map(c => (
                  <ListItemButton key={c.id} selected={selectedCell?.id === c.id} onClick={() => handleCellClick(c)} sx={{
                    '&.Mui-selected': {
                      bgcolor: 'rgba(255, 255, 255, 0.5)',
                      '&:hover': {
                        bgcolor: 'rgba(255, 255, 255, 0.7)',
                      },
                    },
                  }}>
                    <ListItemText
                        primary={c.cellName}
                      />
                  </ListItemButton>
                ))}
            </List>
        </Box>
        <Box role="tabpanel" hidden={value !== 1}>
        <List
              sx={{ width: '100%', maxWidth: 360, bgcolor: 'rgba(0, 0, 0, 0.0)', height: '100%', overflow: 'auto' }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              {filteredUAVData?.map(a => (
                  <ListItemButton key={a.uavId} selected={selectedAircraft?.id === a.uavId} onClick={() => handleUAVlick(a)} sx={{
                    '&.Mui-selected': {
                      bgcolor: 'rgba(255, 255, 255, 0.5)',
                      '&:hover': {
                        bgcolor: 'rgba(255, 255, 255, 0.7)',
                      },
                    },
                  }}>
                    <ListItemText
                        primary={a.uavId}
                      />
                  </ListItemButton>
                ))}
            </List>
        </Box>
      </AccordionDetails>
    </Accordion>
      <DeckGL
        views={useFirstPersonView ? new FirstPersonView({ id: 'first-person', controller: true, fovy: 70 }) : new MapView({ id: 'map-view' })}
        initialViewState={viewState}
        onViewStateChange={({ viewState }) => setViewState(viewState)}
        controller={true}
        layers={[
          new ScenegraphLayer({
            id: '383-3D',
            data: uavData,
            pickable: true,
            scenegraph: MANNA_UAV_MODEL,
            getPosition: d => [d.currentPosition[1],d.currentPosition[0], d.alt.relitive_alt],
            getOrientation: d => [0, (450 - d.compass) % 360, 90],
            _animations: {
              '*': {speed: 1}
            },
            sizeScale: 10,
            _lighting: 'pbr'
          }),
          new ScenegraphLayer({
            id: 'adsb',
            data: ADSBUavs,
            pickable: true,
            scenegraph: 'https://bom-api.s3.eu-west-1.amazonaws.com/simulation/airfrance.glb',
            getPosition: d => d.position,
            getOrientation: d => [0, d.bearing - 20, 90],
            getScale: [1, 1, 1],
            _lighting: 'pbr',
            _animations: {
              '*': {speed: 10}
            },
            sizeScale: 10,
          }),
          new TextLayer({
            id: 'uavLabel',
            data: uavData,
            getText: d => d.uavId,
            getPosition: d => {
              const altitudeOffset = 30;
              return [d.currentPosition[1],d.currentPosition[0], d.alt.relitive_alt + altitudeOffset];
            },
            getSize: 10,
            getColor: [255, 255, 255],
            outlineColor: [0,0,0],
            outlineWidth: 5,
            billboard: true,
            background: true,
            backgroundColor:[0, 0, 0],
            backgroundPadding: [5, 5, 5, 5],
          }),
          new TextLayer({
            id: 'adsbUavLabel',
            data: ADSBUavs,
            getText: d => d.id,
            getPosition: d => {
              const altitudeOffset = 250;
              return [d.position[0], d.position[1], d.position[2] + altitudeOffset];
            },
            getSize: 10,
            getColor: [255, 255, 255],
            outlineColor: [0,0,0],
            outlineWidth: 5,
            billboard: true,
            background: true,
            backgroundColor:[0, 0, 0],
            backgroundPadding: [5, 5, 5, 5],
          }),
          new PointCloudLayer({
            id: 'adsbUavBubble',
            data: ADSBUavs,
            pickable: true,
            pointSize: 200,
            getPosition:   d => d.position,
            getNormal: [0, 1, 0],
            getColor: d => [255,0,0,50],
            sizeUnits: 'meters'
          }),
          new PolygonLayer({
            id: 'obstacles',
            data: obstacleData,
            extruded: true,
            filled: true,
            getElevation: d => 20,
            getFillColor: d => {
              const color = d.geoJson.properties?.color;
              return color ? [color[0], color[1], color[2], 150] : [0, 255, 0, 150];
            },
            getLineColor: d => {
              const color = d.geoJson.properties?.color;
              return color ? [color[0], color[1], color[2], 200] : [0, 255, 0, 200];
            },
            getLineWidth: d => 1,
            getPolygon: d => d.geoJson.geometry.coordinates,
            lineWidthMinPixels: 1,
            stroked: true,
            wireframe: false,
            pickable: true
          }),
          new PolygonLayer({
            id: 'utmVolumes',
            data: modifiedUTMVolumes,
            extruded: true,
            filled: false,
            getElevation: d => d.upper - d.lower,
            getFillColor: d => [...d.color, 50],
            getLineColor: d => [...d.color, 50],
            getLineWidth: d => 1,
            getPolygon: d => d?.volume,
            lineWidthMinPixels: 1,
            stroked: true,
            wireframe: true,
            pickable: true
          }),
          new PolygonLayer({
            id: 'utmSnake',
            data: utmSnake,
            extruded: true,
            filled: true,
            getElevation: d => d.upper - d.lower,
            getFillColor: d => [...d.color, 100],
            getLineColor: d => [...d.color, 300],
            getLineWidth: d => 1,
            getPolygon: d => d.contour,
            lineWidthMinPixels: 1,
            stroked: true,
            wireframe: true,
            pickable: true
          }),
        ]}
        ContextProvider={MapContext.Provider}
      >
        <StaticMap mapStyle={MAP_STYLE} mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN} />
        <NavigationControl style={NAV_CONTROL_STYLE} />
      </DeckGL>
    </Page>
  );
};

const mapDispatchToProps = dispatch => ({

});

export default connect(mapDispatchToProps)(Aerospace3D);
